import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface ClientType {
  id: number
  name: string
  status: number
  usage_count: number
}

interface Props {
  client_types: ClientType[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/client_types" },
  { title: "Client Types", href: "/admin/client_types" },
]

export default function Index({ client_types }: Props) {
  const handleDelete = (id: number, usageCount: number) => {
    const message =
      usageCount > 0
        ? "This type is in use. It will be deactivated instead of deleted. Continue?"
        : "Are you sure you want to delete this type?"

    if (confirm(message)) {
      router.delete(`/admin/client_types/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Client Types" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Client Types</h1>
          <Link
            href="/admin/client_types/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Type
          </Link>
        </div>

        {client_types.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  ID
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  In Use
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {client_types.map((ct) => (
                <tr key={ct.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {ct.id}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {ct.name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {ct.usage_count > 0 ? ct.usage_count : ""}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/client_types/${ct.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(ct.id, ct.usage_count)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No client types found.</p>
        )}
      </div>
    </AppLayout>
  )
}
